export default "__VITE_ASSET__3a146748__"